const getImageUrl = (imageName?: string | null, isPictogram: boolean = false) => {
  if (!imageName) return undefined;

  return `${process.env.PUBLIC_URL}/SelectorImages/${encodeURIComponent(imageName)}${
    isPictogram ? ".svg" : ".webp"
  }`;
};

export { getImageUrl };
